import axios from "axios";
import config from "../config/config";

import { getToken } from "../common";

export const createEventItemAPI = async (params, eventId) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}events/${eventId}/item`,
    data: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default createEventItemAPI;
